import React from 'react';


import HeroSection from '../../organisms/HeroSection/HeroSection';
import AboutSection from '../../organisms/AboutSection/AboutSection';
import RoomsSection from '../../organisms/RoomsSection/RoomsSection';
import PressSection from '../../organisms/PressSection/PressSection';
import ServicesSection from '../../organisms/ServicesSection/ServicesSection';
import ReasonsSection from '../../organisms/ReasonsSection/ReasonsSection';
import TestimonialsSection from '../../organisms/TestimonialsSection/TestimonialsSection';
import InstagramSection from '../../organisms/InstagramSection/InstagramSection';
import LiveFeedSection from '../../organisms/LiveFeedSection/LiveFeedSection';


const Home: React.FC = () => {
  return (
    
    <>
      <HeroSection />
      <AboutSection />
      <RoomsSection />
      <PressSection />
      <ServicesSection />
      <ReasonsSection />
      <TestimonialsSection />
      <InstagramSection />
      <LiveFeedSection />
    </>
  );
};

export default Home;